// extracted by mini-css-extract-plugin
export var inputContainer = "_ol-0";